import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const PerformanceInsightsDataPage = loadAsyncComponent(() => import('./DataPage'), 'page');
